import LegalLayout, { Section } from "@/components/LegalLayout";

export default function ShippingPolicy() {
  return (
    <LegalLayout title="Shipping Policy" eyebrow="Delivered with care" lastUpdated="26 Feb 2026">
      <Section heading="1. Where we ship">
        We currently deliver across all serviceable PIN codes in India. International shipping is
        not available at this time.
      </Section>

      <Section heading="2. Shipping charges">
        {"• Within Gujarat: ₹49\n• Rest of India: ₹99\n• FREE shipping on all orders above ₹499 across India"}
      </Section>

      <Section heading="3. Processing & delivery time">
        {"• Orders are processed within 24-48 hours of payment confirmation (excluding Sundays and public holidays).\n• Standard delivery: 3-7 business days depending on your PIN code.\n• Metro cities & state capitals: typically 3-5 business days.\n• Tier-2/Tier-3 cities & remote areas: 5-7 business days."}
      </Section>

      <Section heading="4. Order tracking">
        {"Once dispatched, you will receive a tracking ID via WhatsApp / email. You can also visit /track-order on blisson.in and enter your order ID to see live status."}
      </Section>

      <Section heading="5. Delayed or lost shipments">
        If your order hasn't arrived within 10 business days, please contact us on WhatsApp with
        your order ID. We will investigate with the courier and either resolve the delivery or
        process a full refund.
      </Section>

      <Section heading="6. Address accuracy">
        Please double-check your shipping address and phone number at checkout. We are not
        responsible for orders shipped to incorrect addresses provided by the customer. Re-shipping
        charges may apply for returned undeliverable parcels.
      </Section>

      <Section heading="7. Salon partner / wholesale orders">
        Bulk orders under the Salon Partner program may be dispatched in 2-3 business days and
        delivered within 5-10 business days. For very large slab-based orders, a dedicated
        partnerships manager will coordinate delivery directly.
      </Section>

      <Section heading="8. Contact us about your shipment">
        {"📞 +91 7383899003 (WhatsApp)\n✉ theblisson@gmail.com"}
      </Section>
    </LegalLayout>
  );
}
